import React from "react";
import {
  Grid,
  Row,
  Col,
  Image,
  Button,
  Alert,
  Modal,
  Tabs,
  Tab,
  FormGroup,
  ControlLabel,
  FormControl,
  ButtonToolbar,
  DropdownButton,
  MenuItem,
} from "react-bootstrap";
import { goTo, FieldGroup } from "../../GlobalTools";
import Select from "react-select";

const DetailItemView = ({
  item,
  readMore,
  readLess,
  reviews,
  count_reviews,
  userActivity,
  toggleWriteReviewModal,
  messages,
  onChangeSelect,
  select_review,
  btn_list,
  isLoading,
  detail_labels,
}) => (
  <div className="item" style={{ backgroundColor: "#434345", height: "100%" }}>
    <Grid>
      <Row className="header-logo">
        <Col xs={12}>
          <img
            src="/assets/img/logo_faver.png"
            className="center-block"
            style={{ height: "24px" }}
          />
        </Col>
      </Row>
      <Row className="header-image" style={{ padding: "8px, 15px" }}>
        <Col
          xs={12}
          className="image-background"
          style={{ backgroundImage: item.background_image_url }}
        >
          <h1 className="text-tile" style={{ color: "red" }}>
            {item.name}
          </h1>
        </Col>
      </Row>

      <div className="mbottom-70">
        <Row>
          <Col xs={12}>
            <p className="txt-white">{item.type}</p>
          </Col>
        </Row>
        <Row>
          <Col xs={8} sm={10}>
            <div
              className="description"
              id="div-ellipsis"
              className="col-xs-12"
            >
              <p id="description-ellipsis" className="txt-white">
                {item.description}
              </p>
              <p
                className="link-green"
                style={{ display: "block" }}
                id="link-ellipsis"
              >
                <a href={item.source_url} className="link-green">
                  {item.domain}
                </a>
              </p>
            </div>
            {/*<div id="div-complete">
                        <p id="description-complete" onClick={() => readLess()}>{item.description}</p>
                        <p className="pull-right  link-green" style={{display: "none"}} id="link-complete"><a onClick={() => readLess()} className="link-green">{item.domain}</a></p>
                    </div>*/}
          </Col>
          <Col xs={4} sm={2} style={{ textAlign: "center" }}>
            <span className="badge item">0%</span>
            <p style={{ color: "#ffffff", paddingTop: "5px" }}>
              Faverability Score
            </p>
          </Col>
        </Row>

        <Row className="mtop-20">
          <Col xs={4}>
            <span className="percentage">
              {item.rotten_tomatoes_score
                ? item.rotten_tomatoes_score + " %"
                : "0%"}
            </span>
            <p className="text-10 txt-white">Rotten Tomatoes</p>
          </Col>
          <Col xs={4} style={{ textAlign: "center" }}>
            <span className="percentage">
              {item.metacritic_score ? item.metacritic_score + " %" : "0%"}
            </span>
            <p className="text-10 txt-white">Metacritic</p>
          </Col>
          <Col xs={4} style={{ textAlign: "right" }}>
            <span className="percentage">
              {item.imdb_score ? item.imdb_score + " %" : "0"}
            </span>
            <p className="text-10 txt-white">IMDb</p>
          </Col>
        </Row>

        <Row className="mtop-20 row-bottoms">
          {btn_list.map(function (btn, index) {
            return (
              <Col xs={4} className="mbottom-20">
                <Button className="col-xs-12 btn btn-black" href={btn.url}>
                  {btn.label}
                </Button>
              </Col>
            );
          })}
        </Row>

        <Row className="section mtop-20">
          <Col xs={12}>
            <Row>
              <Col xs={12}>
                <h4 className="bold-700 tc-white">Details</h4>
              </Col>
            </Row>
            {detail_labels.map(function (detail, index) {
              return detail.label == "Platform" ? (
                detail.value.map(function (platform, indexp) {
                  let index2 = "p" + indexp;
                  return (
                    <Row key={index2}>
                      <Col xs={4}>
                        <p className="text-16 txt-white">
                          {indexp == 0 ? detail.label : ""}
                        </p>
                      </Col>
                      <Col xs={8} style={{ textAlign: "right" }}>
                        <p className="text-16 tc-white">{platform.name}</p>
                      </Col>
                    </Row>
                  );
                })
              ) : (
                <Row key={index}>
                  <Col xs={4}>
                    <p className="text-16 txt-white">{detail.label}</p>
                  </Col>
                  <Col xs={8} style={{ textAlign: "right" }}>
                    <p className="text-16 tc-white">{detail.value}</p>
                  </Col>
                </Row>
              );
            })}
          </Col>
        </Row>

        <Row className="section" style={{ paddingTop: "0" }}>
          <Col xs={12} style={{ paddingLeft: "0", paddingRight: "0" }}>
            <Tabs defaultActiveKey={2} id="icons_activity">
              <Tab eventKey={2} title="Reviews">
                <Row className="mtop-20 mbottom-30">
                  <Col xs={5} sm={9}>
                    <h4 className="bold-700 tc-white">Reviews</h4>
                  </Col>
                  <Col xs={7} sm={3}>
                    <Button
                      className="col-xs-12 btn btn-black"
                      onClick={() => toggleWriteReviewModal(true)}
                    >
                      Write Review{" "}
                    </Button>
                  </Col>
                </Row>

                {/*
                                messages.review ? 
                                    <p className="text-center mtop-20">{messages.review}</p> 
                                :
                                    <Row className="mtop-20 mbottom-30">
                                        <Col xs={6} sm={4} md={3}>
                                            <FormGroup controlId="type-fave">
                                                <div className="conten-select">
                                                    <FormControl onChange={(obj) => onChangeSelect(obj)} value={select_review} componentClass="select">
                                                        <option value="all">All</option>
                                                        <option value="up_fave">Faved</option>
                                                        <option value="down_fave">Disfaved</option>
                                                        <option value="newest">Newest</option>
                                                        <option value="oldest">Oldest</option>
                                                    </FormControl>
                                                </div>
                                            </FormGroup>                                
                                        </Col>
                                        <Col xs={6} sm={8} md={9}>
                                            <p className="pull-right" style={{marginTop: "10px"}}>{count_reviews} Fave Reviews</p>
                                        </Col>
                                    </Row>
                            */}
                <Row className="mtop-20 mbottom-70">
                  <Col xs={6} sm={4} md={3}>
                    <FormGroup controlId="type-fave">
                      <div className="conten-select">
                        <FormControl
                          onChange={(obj) => onChangeSelect(obj)}
                          value={select_review}
                          componentClass="select"
                        >
                          <option value="all">All</option>
                          <option value="up_fave">Faved</option>
                          <option value="down_fave">Disfaved</option>
                          <option value="newest">Newest</option>
                          <option value="oldest">Oldest</option>
                        </FormControl>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xs={6} sm={8} md={9}>
                    <p
                      className="pull-right txt-white"
                      style={{ marginTop: "10px" }}
                    >
                      {count_reviews} Fave Reviews
                    </p>
                  </Col>

                  {isLoading ? (
                    <Col xs={12}>
                      <img
                        src="/assets/img/spinner-green.gif"
                        className="center-block"
                        width="40px"
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>

                {reviews.map(function (review, index) {
                  return (
                    <div className="mtop-20 row-review" key={index}>
                      <Row>
                        <Col xs={7} sm={8}>
                          <div
                            className="col-thumbail"
                            style={{ backgroundImage: review.user_img_url }}
                          ></div>
                          <p>{review.user_id.username}</p>
                        </Col>
                        <Col xs={5} sm={4}>
                          <p className="pull-right txt-white">
                            {review.month_review} {review.day_review},{" "}
                            {review.year_review}
                          </p>
                        </Col>
                        <Col xs={12} className="text-review">
                          <p className="txt-white">{review.review}</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <div className="pull-right">
                            <div className="text-right btn-fave">
                              <span
                                onClick={() => toggleWriteReviewModal(true)}
                                style={{ cursor: "pointer" }}
                              >
                                <img
                                  src="/assets/img/icons/fave_grey_lt.png"
                                  className="center-block activity-icon"
                                  style={{ marginRight: "0" }}
                                />
                                <p
                                  className="tc-white"
                                  style={{ display: "inline-block" }}
                                >
                                  {review.faves.up_fave}
                                </p>
                              </span>
                            </div>

                            <div className="text-right btn-disfave">
                              <span
                                onClick={() => toggleWriteReviewModal(true)}
                                style={{ cursor: "pointer" }}
                              >
                                <img
                                  src="/assets/img/icons/disfave_grey_lt.png"
                                  className="center-block activity-icon"
                                  style={{ marginRight: "0" }}
                                />
                                <p
                                  className="tc-white"
                                  style={{ display: "inline-block" }}
                                >
                                  {review.faves.down_fave}
                                </p>
                              </span>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </Tab>
              <Tab eventKey={1} title="Activity">
                <Row
                  className="mtop-20 mbottom-20"
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                  }}
                >
                  <Col xs={12}>
                    <div className="col-5 text-center">
                      <span
                        onClick={() => toggleWriteReviewModal(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src="/assets/img/icons/tiny_faver.png"
                          className="center-block activity-icon"
                        />
                        <p
                          style={{ display: "inline-block" }}
                          className="txt-white"
                        >
                          {item.activity_up_faves}
                        </p>
                      </span>
                    </div>
                    <div className="col-5 text-center">
                      <span
                        onClick={() => toggleWriteReviewModal(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src="/assets/img/icons/tiny disfave.png"
                          className="center-block activity-icon"
                        />
                        <p
                          style={{ display: "inline-block" }}
                          className="txt-white"
                        >
                          {item.activity_down_faves}
                        </p>
                      </span>
                    </div>
                    <div className="col-5 text-center">
                      <span
                        onClick={() => toggleWriteReviewModal(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src="/assets/img/icons/tiny share.png"
                          className="center-block activity-icon"
                        />
                        <p
                          style={{ display: "inline-block" }}
                          className="txt-white"
                        >
                          {item.activity_sends}
                        </p>
                      </span>
                    </div>
                    <div className="col-5 text-center">
                      <span
                        onClick={() => toggleWriteReviewModal(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src="/assets/img/icons/tiny add.png"
                          className="center-block activity-icon"
                        />
                        <p
                          style={{ display: "inline-block" }}
                          className="txt-white"
                        >
                          {item.activity_adds_to_list}
                        </p>
                      </span>
                    </div>
                    <div className="col-5 text-center">
                      <span
                        onClick={() => toggleWriteReviewModal(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src="/assets/img/icons/tiny save.png"
                          className="center-block activity-icon"
                        />
                        <p
                          style={{ display: "inline-block" }}
                          className="txt-white"
                        >
                          {item.activity_bucket}
                        </p>
                      </span>
                    </div>
                  </Col>
                </Row>
                {userActivity.map(function (activity, index) {
                  return (
                    <div className="mtop-10 row-activity" key={index}>
                      <Row>
                        <Col xs={12}>
                          <div
                            className="col-thumbail activity-thumbail"
                            style={{
                              backgroundImage: activity.activity_image_url,
                            }}
                          ></div>
                          <p>
                            {activity.first_name} {activity.last_name}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
                {messages.activity ? (
                  <p className="text-center">{messages.activity}</p>
                ) : (
                  ""
                )}
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </div>

      <Row>
        <Col xs={12}>
          <nav className="navbar navbar-default navbar-fixed-bottom">
            <div className="container">
              <Row className="mtop-20 mbottom-20">
                <Col xs={12}>
                  <div className="col-5 text-center">
                    <span
                      onClick={() => toggleWriteReviewModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="/assets/img/icons/tiny_faver.png"
                        className="center-block activity-icon"
                      />
                      <p
                        className="tc-white"
                        style={{ display: "inline-block" }}
                      >
                        {item.activity_up_faves}
                      </p>
                    </span>
                  </div>
                  <div className="col-5 text-center">
                    <span
                      onClick={() => toggleWriteReviewModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="/assets/img/icons/tiny disfave.png"
                        className="center-block activity-icon"
                      />
                      <p
                        className="tc-white"
                        style={{ display: "inline-block" }}
                      >
                        {item.activity_down_faves}
                      </p>
                    </span>
                  </div>
                  <div className="col-5 text-center">
                    <span
                      onClick={() => toggleWriteReviewModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="/assets/img/icons/tiny share.png"
                        className="center-block activity-icon"
                      />
                      <p
                        className="tc-white"
                        style={{ display: "inline-block" }}
                      >
                        Send
                      </p>
                    </span>
                  </div>
                  <div className="col-5 text-center">
                    <span
                      onClick={() => toggleWriteReviewModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="/assets/img/icons/tiny add.png"
                        className="center-block activity-icon"
                      />
                      <p
                        className="tc-white"
                        style={{ display: "inline-block" }}
                      >
                        Add
                      </p>
                    </span>
                  </div>
                  <div className="col-5 text-center">
                    <span
                      onClick={() => toggleWriteReviewModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="/assets/img/icons/tiny save.png"
                        className="center-block activity-icon"
                      />
                      <p
                        className="tc-white"
                        style={{ display: "inline-block" }}
                      >
                        Bucket
                      </p>
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
          </nav>
        </Col>
      </Row>
    </Grid>
  </div>
);

export default DetailItemView;



// WEBPACK FOOTER //
// ./src/client/views/items/DetailItemView.js